
document.documentElement.classList.remove('no-js');

const glow = document.getElementById('cursorGlow');
if (glow) {
  window.addEventListener('pointermove', (e) => {
    glow.style.left = e.clientX + 'px';
    glow.style.top = e.clientY + 'px';
  });
}

const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) entry.target.classList.add('visible');
  });
}, { threshold: 0.1 });

document.querySelectorAll('.reveal').forEach((el) => revealObserver.observe(el));

document.addEventListener('change', (e) => {
  if (e.target.matches('[data-variant-select]')) {
    const option = e.target.selectedOptions[0];
    const form = e.target.closest('form');
    if (!form || !option) return;
    const idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = option.value;
    const price = form.closest('.product-details')?.querySelector('[data-product-price]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
  }
});
